import { ChevronRightOutlined } from "@mui/icons-material";
import { Box, Button, Stack, Theme, Typography, useTheme } from "@mui/material";
import { ROUTES } from "helpers/routes";
import { useNavigate } from "react-router-dom";

const ThankYou = () => {
  const theme: Theme = useTheme();
  const navigate = useNavigate();

  return (
    <Stack
      justifyContent="center"
      alignItems="center"
      spacing={5}
      sx={{
        width: "100%",
        maxWidth: 500,
        margin: "0 auto",
        borderRadius: 3,
        overflow: "hidden",
        marginTop: 6,
        padding: theme.spacing(2),
        paddingTop: theme.spacing(4),
        color: theme.palette.common.white,
      }}
    >
      <svg
        width="128"
        height="128"
        viewBox="0 0 128 128"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle cx="64" cy="64" r="64" fill="#fff" />
        <path
          d="m34 66 6-6 13 8s16.841-16.75 39-28l2 7S70.273 60.955 53 88z"
          fill="#0E52A4"
        />
      </svg>

      <Box>
        <Typography variant="h1" align="center" gutterBottom>
          Thank you!
        </Typography>
        <Typography variant="body1" align="center" gutterBottom>
          We have sent your notification to the founder
        </Typography>
      </Box>

      <Button
        variant="white"
        onClick={() => navigate(ROUTES.HOME)}
        style={{ paddingInline: theme.spacing(8) }}
        endIcon={<ChevronRightOutlined />}
      >
        Explore Orbit
      </Button>
    </Stack>
  );
};

export default ThankYou;
